namespace Matrix.Rebalancer {
    export interface HoldingWhitelistRow {
        AccountCode?: string;
        SecurityId?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountRowId?: number;
        AccountName?: string;
        AccountTypeCode?: string;
        AccountRoleCode?: string;
        AccountManagerCode?: string;
        SecurityRowId?: number;
        SecurityCode?: string;
        SecurityName?: string;
        SecurityTypeCode?: string;
    }

    export namespace HoldingWhitelistRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Rebalancer.HoldingWhitelist';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            AccountCode = "AccountCode",
            SecurityId = "SecurityId",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountRowId = "AccountRowId",
            AccountName = "AccountName",
            AccountTypeCode = "AccountTypeCode",
            AccountRoleCode = "AccountRoleCode",
            AccountManagerCode = "AccountManagerCode",
            SecurityRowId = "SecurityRowId",
            SecurityCode = "SecurityCode",
            SecurityName = "SecurityName",
            SecurityTypeCode = "SecurityTypeCode"
        }
    }
}
